import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import WhySpreadsheetSection from './components/WhySpreadsheetSection';
import FeaturesSection from './components/FeaturesSection';
import BlogPreviewSection from './components/BlogPreviewSection';
import SeoContentSection from './components/SeoContentSection';
import FooterSection from './components/FooterSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://pandabuy.cam';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'PandabuySpreadsheet',
  url: siteUrl,
  description: 'Smart product comparison and research hub using structured spreadsheet insights for data-driven buying decisions.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'PandabuySpreadsheet',
  url: siteUrl,
  description: 'Product comparison and research intelligence hub providing structured spreadsheet insights for smarter shopping decisions.',
  sameAs: ['https://kaspreadsheet.com'],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <main className="min-h-screen">
        <Navbar />
        <HeroSection />
        <CategoryGrid />
        <WhySpreadsheetSection />
        <FeaturesSection />
        <BlogPreviewSection />
        <SeoContentSection />
        <FooterSection />
      </main>
    </>
  );
}